<div style="overflow: hidden !important; " >
    <div style="overflow: hidden;" fxLayout="column" fxLayoutAlign="space-around"  fxLayoutGap="20px">

    <br/>

      <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="center">
        <div fxLayout="column" fxLayout.xs="row" fxFlex="5"></div>

        <div fxLayout="column" fxLayout.xs="row" fxFlex="45" class="auto_margin"  fxLayoutAlign="center center">
          <img style="height: auto;width: 80%"
          src="https://storage.googleapis.com/jivrus-web-images/products/appiworks/appiworks-logo-3d.png"
          class="" alt="" loading="eager" />
        </div>

        <div fxLayout="column"  fxFlex="45"  fxLayoutAlign="center center">
            <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center">
                <span class="mat-headline-2 auto_margin" i18n><b>{{ 'AppiWorks  - Application Integration works' | translate}}</b> </span>
                <!-- <span> <h1></h1></span> -->
            </div>

         <div fxLayout="row" [@openClose]="isOpen" style=" color: #b86814;text-align: center;height: 100px;" fxLayoutAlign="center center"
         class="mat-headline-3 auto_margin">
                <b>{{ changing_qoute }}</b>
            </div>
          </div>

        <!-- </div> -->

        <div fxLayout="column" fxFlex="5"></div>
      </div>

      <!-- <div fxLayout="row" class="auto_margin">
        <div fxLayout="column" fxFlex="20"></div>
        <div fxLayout="column" fxFlex="60" fxLayoutAlign="center center">
          <img style="height: auto;width: 100%"
          src="https://storage.googleapis.com/jivrus-web-images/products/appiworks/appiworks-text-horizontal.png"
          class="" alt="" loading="eager" />
        </div>
        <div fxLayout="column" fxFlex="20"></div>
      </div> -->

      <div fxLayout="row" >
        <div fxLayout="column" fxFlex="10"></div>
        <div fxLayout="column" fxFlex="80" style="text-align: justify;" ngStyle.xs="font-size: 16px" class="mat-headline-4"  fxLayoutAlign="center center">
          {{ 'guest.products_banner_description'| translate }}
        </div>
        <div fxLayout="column" fxFlex="10"></div>
      </div>

      <div fxLayout="row" >
        <div fxLayout="column" fxFlex="5"></div>
        <div fxLayout="column" fxFlex="90" class="mat-headline-4 auto_margin"  fxLayoutAlign="center center">
          <b><u>{{ 'guest.key_features'| translate }}</u></b>
        </div>
        <div fxLayout="column" fxFlex="5"></div>
      </div>

      <div fxLayout="row wrap" fxLayoutAlign="center">
        <div *ngFor="let product of products; let i = index" >
        <div class="card-size">
          <a style="text-decoration: none;" [href]="product.pagePath" target="_blank">
            <mat-card appearance="outlined" class="card-1 mat-card-custom" style="cursor: pointer;">
              <div fxLayout="row" fxLayoutAlign="center center" class="product-name">
                <b>{{ product.name }}</b>
              </div>
              <div fxLayout="row" fxLayoutAlign="center center" 
                   (mouseleave)="iconMouseLeave(product)" 
                   (mouseenter)="iconMouseEnter(product)">
                <img [src]="baseURL + product.logoPath" 
                     [@rotateState]="rotationStates[product.id]" 
                     class="product-icon">
              </div>
              <div class="mat-h2 auto_margin" fxLayout="row" fxLayoutAlign="center center" ngStyle.xs="text-align: center">
                <b>{{ getProductTranslationString(product.id, "tagline") | translate }}</b>
              </div>
              <div fxLayout="row" class="mat-h3 auto_margin" fxLayoutAlign="center center">
                {{ getProductTranslationString(product.id, "description") | translate }}
              </div>
              <div fxLayout="row" class="mat-h2 auto_margin" fxLayoutAlign="center center">
                <b>
                  <ng-container *ngFor="let j of [0, 1, 2]; let last = last">
                    {{ translate.instant(getProductTranslationString(product.id, "keywords") + "." + j) }}<span *ngIf="!last"> | </span>
                  </ng-container>
                </b>
              </div>
            </mat-card>
          </a>
        </div>
      </div>
      </div>
    
      <br/><br/><br/>
    </div>
    </div>
